module.exports = __webpack_public_path__ + "static/media/red_info_icon.07b2ed66.svg";